const ApiCtl = {
  /**
   根据设备id查询该设备实时位置信息、该设备信息、该设备所属组织信息、可查看多个设备、至少选择一个设备查看、列表无分页
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  getLocationByDevIdRoute (_this, url, devId, BMap) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        devId: devId
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        // 增加一个marker ，地图上的标记
        // 安全帽设备
        _this.devName = res.data.data.pag.devName
        _this.myIcon = _this.$cautionIconFun.setIconAndPopupHtmlLLMap(_this, res.data.data.pag)
        _this.$L.marker([res.data.data.pag.lLatWgs84 * 1, res.data.data.pag.lLonWgs84 * 1], {
          icon: _this.myIcon
        }).addTo(_this.leafletMap)
        _this.leafletMap.setView([res.data.data.pag.lLatWgs84 * 1, res.data.data.pag.lLonWgs84 * 1], 16)
      } else {
      }
    })
  },
  /**
   根据各种条件查询轨迹回放
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   * @param searchData {Object} 查询条件
   */
  getRouteByDevId (_this, url, searchData) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        devId: searchData.devId,
        selectCondition: searchData.condition,
        beginTime: searchData.beginTime,
        endTime: searchData.endTime
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200 && res.data.data !== null) {
        if (res.data.data.length > 0) {
          let arr = document.getElementsByClassName('btn_ctr')
          arr[0].classList.remove('replayBtn')
          _this.play = false
          _this.pointNum = 0
          _this.routeTotalMileage = 0
          let routeTotalTime = 0
          for (let item in res.data.data) {
            _this.pointNum = _this.pointNum + res.data.data[item].locationList.length
            if (res.data.data[item].route !== null && res.data.data[item].route !== '') {
              _this.routeTotalMileage = _this.routeTotalMileage + res.data.data[item].route.routeTotalMileage / 1000
              routeTotalTime = routeTotalTime + res.data.data[item].route.routeTotalTime
            }
          }
          if (routeTotalTime !== 0) {
            let hour = routeTotalTime / 3600000
            let second = routeTotalTime % 3600000
            let minute = parseInt(second / 60000)
            let ss = second % 60000
            _this.routeTotalTime = parseInt(hour).toString() + '时' + minute.toString() + '分' + ss / 1000 + '秒'
            if (_this.routeTotalMileage === 0) {
              _this.routeSpeed = 0
            } else {
              _this.routeSpeed = (_this.routeTotalMileage / hour).toFixed(2)
            }
          }
          _this.trackerPointList = []
          _this.cautionPointList = []
          _this.watchDeviceList = res.data.data
          for (let item in res.data.data) {
            _this.trackerPointList = _this.trackerPointList.concat(res.data.data[item].locationList)
            if (res.data.data[item].route !== null && res.data.data[item].route !== '') {
              let lng = res.data.data[item].route.routeBeginLon * 1
              let lat = res.data.data[item].route.routeBeginLat * 1
              let endLng = res.data.data[item].route.routeEndLon * 1
              let endLat = res.data.data[item].route.routeEndLat * 1
              _this.watchDeviceList[item].begigCoordinate = lng.toFixed(6) + ',' + lat.toFixed(6)
              _this.watchDeviceList[item].endCoordinate = endLng.toFixed(6) + ',' + endLat.toFixed(6)
            }
          }
          for (let item in _this.trackerPointList) {
            if (_this.trackerPointList[item].cType !== '' && _this.trackerPointList[item].cType !== null) {
              _this.cautionPointList.push(_this.trackerPointList[item])
            }
            let lng = _this.trackerPointList[item].lLonWgs84 * 1
            let lat = _this.trackerPointList[item].lLatWgs84 * 1
            _this.trackerPointList[item].coordinate = lng.toFixed(6) + ',' + lat.toFixed(6)
          }
          _this.maxRoute = _this.trackerPointList.length
          _this.drawPolyline(res.data.data)
        } else {
          _this.mapLoading = false
          _this.watchDeviceList = []
          _this.routeTotalMileage = 0
          _this.routeTotalTime = '0时0分0秒'
          _this.routeSpeed = 0
          _this.pointNum = 0
          _this.$message({
            message: '当前所选时间范围暂无行程信息！',
            type: 'warning'
          })
        }
      } else {
        _this.mapLoading = false
        _this.$message({
          message: res.data.message,
          type: 'warning'
        })
      }
    })
  }
}
export default ApiCtl



// WEBPACK FOOTER //
// ./src/javascript/leafletTest/test.js